import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as LinkSvg } from "../../../../assets/link.svg";
import { Button, Form, Label } from "semantic-ui-react";
import { Formik, ErrorMessage, FieldArray } from "formik";
import { ReactComponent as ThumbsUpSvg } from "../../../../assets/navbericon/thumbsup.svg";
import { ReactComponent as InfoDotGreenSvg } from "../../../../assets/infodotgreen.svg";
import { ReactComponent as GreenDropDownIcon } from "../../../../assets/greendropdown.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as EditButtonSvg } from "../../../../assets/useredit.svg";
import { ReactComponent as UploadHeaderSvg } from "../../../../assets/UploadHeader.svg";
import { ReactComponent as UploadLogoSvg } from "../../../../assets/UploadLogo.svg";
import { ReactComponent as BackArrowSvg } from "../../../../assets/backarrow.svg";
import Modal from "../../../../app/common/modals/Custom";
import { InputTemp, SelectTemp } from "../../../../app/common/form/Custom";
import { vendorSchema } from "../../../../app/validation/validationSchema";
import { useStore } from "../../../../app/stores/store";
import Loading from "../../../../app/layout/Loading";
import { observer } from "mobx-react-lite";
import { AccountInformation } from "../../../../app/models/user";
import responseCodes from "../../../../app/common/hooks/helpers";
import MyTextArea from "../../../../app/common/form/MyTextArea";
import {
  regionOptions,
  stateOptions,
} from "../../../../app/common/options/categoryOptions";
import { Checkbox, FormControlLabel } from "@mui/material";
import {
  RegionPriceForm,
  ShippingLocationPriceForm,
  ShippingPriceForm,
  ShippingPriceStatus,
  StatePriceForm,
} from "../../../../app/models/shipping";
import MyTextInput from "../../../../app/common/form/MyTextInput";
import { toast } from "react-toastify";

const ShippingLocationIndex = () => {
  const [modal, setModal] = useState("");
  const navigate = useNavigate();
  const [inputField, setInputField] = useState(new ShippingLocationPriceForm());
  const [activeOption, setActiveOption] = useState("region");
  const [stateSelected, setStateSelected] = useState("Abia");
  const [regionSelected, setRegionSelected] = useState("North Central");
  const { shippingStore } = useStore();
  const {
    loadingInitial,
    stateList,
    regionList,
    initialValues,
    getVendorShippingPriceLocations,
    addStatePriceLocations,
    addRegionPriceLocations,
  } = shippingStore;

  const handleRegionEntityCheck = (
    value: any,
    values: ShippingLocationPriceForm,
    setValues: any
  ) => {
    var updatedRegionList = [...values.regionList];
    var updatedShippingPriceList = [...values.shippingPriceList];

    // if check didn't exist
    if (
      values.regionList.findIndex((region) => region.region === value) === -1
    ) {
      const newRegionForm =
        regionList[
          regionList!.findIndex((region) => region.regionId === value)
        ];
      // add check
      updatedRegionList = [...values.regionList, newRegionForm];
      updatedShippingPriceList[
        updatedShippingPriceList.findIndex((price) => price.region === value)
      ].status = ShippingPriceStatus.true;
    }
    // if check exists
    else {
      updatedRegionList.splice(
        updatedRegionList.findIndex((region) => region.region === value),
        1
      );
      updatedShippingPriceList[
        updatedShippingPriceList.findIndex((price) => price.region === value)
      ].status = ShippingPriceStatus.false;
    }

    setValues({
      ...values,
      regionList: updatedRegionList,
      shippingPriceList: updatedShippingPriceList,
    });
  };

  const handleStateEntityCheck = (
    value: any,
    values: ShippingLocationPriceForm,
    setValues: any
  ) => {
    // region
    var updatedStateList = [...values.stateList];
    var updatedShippingPriceList = [...values.shippingPriceList];

    // if check didn't exist
    if (values.stateList.findIndex((state) => state.state === value) === -1) {
      const newStateForm =
        stateList[stateList!.findIndex((state) => state.stateId === value)];
      // add check
      updatedStateList = [...values.stateList, newStateForm];
      updatedShippingPriceList[
        updatedShippingPriceList.findIndex((price) => price.state === value)
      ].status = ShippingPriceStatus.true;
    }
    // if check exists
    else {
      updatedStateList.splice(
        updatedStateList.findIndex((state) => state.state === value),
        1
      );
      updatedShippingPriceList[
        updatedShippingPriceList.findIndex((price) => price.state === value)
      ].status = ShippingPriceStatus.false;
    }

    setValues({
      ...values,
      stateList: updatedStateList,
      shippingPriceList: updatedShippingPriceList,
    });
  };

  const saveForm = (values: ShippingLocationPriceForm) => {
    if (activeOption === "state") {
      const payload = values.shippingPriceList.filter((value) => {
        return (
          // value.state &&
          value.status === ShippingPriceStatus.true || value.shippingPriceId
        );
      });
      addStatePriceLocations(payload).then((res) => {
        if (res?.responseCode === responseCodes.response_00) {
          toast.info(res.responseMessage);
          setModal("success");
        }
      });
    } else {
      const payload = values.shippingPriceList.filter((value) => {
        return (
          // value.region &&
          value.status === ShippingPriceStatus.true || value.shippingPriceId
        );
      });
      addRegionPriceLocations(payload).then((res) => {
        if (res?.responseCode === responseCodes.response_00) {
          toast.info(res.responseMessage);
          setModal("success");
        }
      });
    }
  };

  useEffect(() => {
    getVendorShippingPriceLocations();
  }, []);
  return (
    <div className={styles.page}>
      {loadingInitial === "loading" && <Loading />}
      {modal === "success" && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => {
            setModal("");
            navigate("/vendor/shipping");
          }}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <ThumbsUpSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>Saved successfully</p>
            </div>

            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => navigate("/vendor/shipping")}
              >
                <div className={styles.button}>
                  <span>Okay!</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <div className={styles.back}>
        <BackArrowSvg onClick={() => navigate(-1)} />
        <span>Go back</span>
      </div>
      <div className={styles.headerTitle}>Choose a region or state</div>
      <Formik
        initialValues={initialValues ? initialValues : inputField}
        enableReinitialize
        onSubmit={saveForm}
        validationSchema={
          // activeOption === "state"
          //   ? vendorSchema.shippingStateSettings
          //   :
          vendorSchema.shippingRegionSettings
        }
      >
        {({
          dirty,
          errors,
          getFieldProps,
          handleSubmit,
          values,
          setValues,
          setFieldValue,
          isValid,
          isSubmitting,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FieldArray
                name="shippingPriceList"
                render={(arrayHelpers) => {
                  let shippingPriceList = values.shippingPriceList;
                  const vendorRegionList = values.regionList;
                  const vendorStateList = values.stateList;
                  return (
                    <div className={styles.form}>
                      <div className={styles.locationSettingsOptions}>
                        <div
                          className={`${styles.regionOption} ${
                            activeOption === "region" && styles.active
                          }`}
                          onClick={() => {
                            setActiveOption("region");
                            // toggleState(values, setValues);
                          }}
                        >
                          <h4>Region</h4>
                          <p>Select from the geopolitical zones in Nigeria</p>
                        </div>
                        <div
                          className={`${styles.stateOption} ${
                            activeOption === "state" && styles.active
                          }`}
                          onClick={() => {
                            setActiveOption("state");
                            // toggleState(values, setValues);
                          }}
                        >
                          <h4>State</h4>
                          <p>Select from the geopolitical zones in Nigeria</p>
                        </div>
                      </div>
                      {activeOption === "region" && (
                        <div className={styles.column2}>
                          <div className={styles.flexForm1}>
                            <div className={styles.searchForm}></div>
                            <div className={styles.locationOptions}>
                              {regionList.map((region, index) => {
                                return (
                                  <div
                                    className={`${styles.locationOption} ${
                                      regionSelected === region.region &&
                                      styles.selected
                                    }`}
                                    key={`region${index}`}
                                  >
                                    <FormControlLabel
                                      // disabled
                                      control={
                                        <Checkbox
                                          color="success"
                                          // sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                                          checked={
                                            vendorRegionList.findIndex(
                                              (x) => x.region === region.region
                                            ) !== -1 &&
                                            shippingPriceList[
                                              shippingPriceList.findIndex(
                                                (x) =>
                                                  x.region === region.region
                                              )
                                            ].status ===
                                              ShippingPriceStatus.true
                                          }
                                        />
                                      }
                                      label={
                                        <p
                                          className={`${
                                            styles.selectedoption
                                          } ${
                                            vendorRegionList.findIndex(
                                              (x) => x.region === region.region
                                            ) !== -1 &&
                                            shippingPriceList[
                                              shippingPriceList.findIndex(
                                                (x) =>
                                                  x.region === region.region
                                              )
                                            ].status ===
                                              ShippingPriceStatus.true &&
                                            styles.green
                                          }`}
                                          onClick={() => {
                                            setRegionSelected(region.region);
                                          }}
                                        >
                                          {region.region}
                                        </p>
                                      }
                                      onClick={(e) => {
                                        handleRegionEntityCheck(
                                          region.region,
                                          values,
                                          setValues
                                        );
                                        setRegionSelected(region.region);
                                      }}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                          {shippingPriceList.length > 0 &&
                            shippingPriceList
                              .filter((price, index) => {
                                return regionSelected === price.region;
                              })
                              .map((price, index) => {
                                return (
                                  <div
                                    className={styles.flexForm2}
                                    key={shippingPriceList.findIndex(
                                      (x) => x.region === regionSelected
                                    )}
                                  >
                                    <div className={styles.titleFlex}>
                                      <div className={styles.weightFlex}>
                                        Standard (KG)
                                      </div>
                                      <div className={styles.priceFlex}>
                                        Price (₦)
                                      </div>
                                    </div>
                                    <hr />
                                    <div className={styles.weightInput}>
                                      <div className={styles.weightRange}>
                                        0kg - 5kg
                                      </div>
                                      <div className={styles.weightTextBox}>
                                        <div>
                                          <InputTemp
                                            inputType="number"
                                            placeholder=""
                                            {...getFieldProps(
                                              `shippingPriceList[${shippingPriceList.findIndex(
                                                (x) =>
                                                  x.region === regionSelected
                                              )}].fiveKgPrice`
                                            )}
                                          />
                                          <ErrorMessage
                                            name={`shippingPriceList[${shippingPriceList.findIndex(
                                              (x) => x.region === regionSelected
                                            )}].fiveKgPrice`}
                                            render={(error) => (
                                              <Label
                                                basic
                                                color="red"
                                                content={error}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className={styles.weightInput}>
                                      <div className={styles.weightRange}>
                                        5kg - 10kg
                                      </div>
                                      <div className={styles.weightTextBox}>
                                        <div>
                                          <InputTemp
                                            inputType="number"
                                            placeholder=""
                                            {...getFieldProps(
                                              `shippingPriceList[${shippingPriceList.findIndex(
                                                (x) =>
                                                  x.region === regionSelected
                                              )}].tenKgPrice`
                                            )}
                                          />
                                          <ErrorMessage
                                            name={`shippingPriceList[${shippingPriceList.findIndex(
                                              (x) => x.region === regionSelected
                                            )}].tenKgPrice`}
                                            render={(error) => (
                                              <Label
                                                basic
                                                color="red"
                                                content={error}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className={styles.weightInput}>
                                      <div className={styles.weightRange}>
                                        10kg - 25kg
                                      </div>
                                      <div className={styles.weightTextBox}>
                                        <div>
                                          <InputTemp
                                            inputType="number"
                                            placeholder=""
                                            {...getFieldProps(
                                              `shippingPriceList[${shippingPriceList.findIndex(
                                                (x) =>
                                                  x.region === regionSelected
                                              )}].twentyFiveKgPrice`
                                            )}
                                          />
                                          <ErrorMessage
                                            name={`shippingPriceList[${shippingPriceList.findIndex(
                                              (x) => x.region === regionSelected
                                            )}].twentyFiveKgPrice`}
                                            render={(error) => (
                                              <Label
                                                basic
                                                color="red"
                                                content={error}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className={styles.weightInput}>
                                      <div className={styles.weightRange}>
                                        25kg & Above
                                      </div>
                                      <div className={styles.weightTextBox}>
                                        <div>
                                          <InputTemp
                                            inputType="number"
                                            placeholder=""
                                            {...getFieldProps(
                                              `shippingPriceList[${shippingPriceList.findIndex(
                                                (x) =>
                                                  x.region === regionSelected
                                              )}].aboveKgPrice`
                                            )}
                                          />
                                          <ErrorMessage
                                            name={`shippingPriceList[${shippingPriceList.findIndex(
                                              (x) => x.region === regionSelected
                                            )}].aboveKgPrice`}
                                            render={(error) => (
                                              <Label
                                                basic
                                                color="red"
                                                content={error}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                        </div>
                      )}
                      {activeOption === "state" && (
                        <div className={styles.column2}>
                          <div className={styles.flexForm1}>
                            <div className={styles.searchForm}></div>
                            <div className={styles.locationOptions}>
                              {stateList.map((state, index) => {
                                return (
                                  <div
                                    className={`${styles.locationOption} ${
                                      stateSelected === state.state &&
                                      styles.selected
                                    }`}
                                    key={`state${index}`}
                                  >
                                    <FormControlLabel
                                      // disabled
                                      control={
                                        <Checkbox
                                          color="success"
                                          checked={
                                            vendorStateList.findIndex(
                                              (x) => x.state === state.state
                                            ) !== -1 &&
                                            shippingPriceList[
                                              shippingPriceList.findIndex(
                                                (x) => x.state === state.state
                                              )
                                            ].status ===
                                              ShippingPriceStatus.true
                                          }
                                        />
                                      }
                                      label={
                                        <p
                                          className={`${
                                            styles.selectedoption
                                          } ${
                                            vendorStateList.findIndex(
                                              (x) => x.state === state.state
                                            ) !== -1 &&
                                            shippingPriceList[
                                              shippingPriceList.findIndex(
                                                (x) => x.state === state.state
                                              )
                                            ].status ===
                                              ShippingPriceStatus.true &&
                                            styles.green
                                          }`}
                                          onClick={() => {
                                            setStateSelected(state.state);
                                          }}
                                        >
                                          {state.state}
                                        </p>
                                      }
                                      onClick={(e) => {
                                        handleStateEntityCheck(
                                          state.state,
                                          values,
                                          setValues
                                        );

                                        setStateSelected(state.state);
                                      }}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          {shippingPriceList.length > 0 &&
                            shippingPriceList
                              .filter((price, index) => {
                                return stateSelected === price.state;
                              })
                              .map((price, index) => {
                                return (
                                  <div
                                    className={styles.flexForm2}
                                    key={shippingPriceList.findIndex(
                                      (x) => x.state === stateSelected
                                    )}
                                  >
                                    <div className={styles.titleFlex}>
                                      <div className={styles.weightFlex}>
                                        Standard (KG)
                                      </div>
                                      <div className={styles.priceFlex}>
                                        Price (₦)
                                      </div>
                                    </div>
                                    <hr />
                                    <div className={styles.weightInput}>
                                      <div className={styles.weightRange}>
                                        0kg - 5kg
                                      </div>
                                      <div className={styles.weightTextBox}>
                                        <div>
                                          <InputTemp
                                            inputType="number"
                                            placeholder=""
                                            {...getFieldProps(
                                              `shippingPriceList[${shippingPriceList.findIndex(
                                                (x) => x.state === stateSelected
                                              )}].fiveKgPrice`
                                            )}
                                          />
                                          <ErrorMessage
                                            name={`shippingPriceList[${shippingPriceList.findIndex(
                                              (x) => x.state === stateSelected
                                            )}].fiveKgPrice`}
                                            render={(error) => (
                                              <Label
                                                basic
                                                color="red"
                                                content={error}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className={styles.weightInput}>
                                      <div className={styles.weightRange}>
                                        5kg - 10kg
                                      </div>
                                      <div className={styles.weightTextBox}>
                                        <div>
                                          <InputTemp
                                            inputType="number"
                                            placeholder=""
                                            {...getFieldProps(
                                              `shippingPriceList[${shippingPriceList.findIndex(
                                                (x) => x.state === stateSelected
                                              )}].tenKgPrice`
                                            )}
                                          />
                                          <ErrorMessage
                                            name={`shippingPriceList[${shippingPriceList.findIndex(
                                              (x) => x.state === stateSelected
                                            )}].tenKgPrice`}
                                            render={(error) => (
                                              <Label
                                                basic
                                                color="red"
                                                content={error}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className={styles.weightInput}>
                                      <div className={styles.weightRange}>
                                        10kg - 25kg
                                      </div>
                                      <div className={styles.weightTextBox}>
                                        <div>
                                          <InputTemp
                                            inputType="number"
                                            placeholder=""
                                            {...getFieldProps(
                                              `shippingPriceList[${shippingPriceList.findIndex(
                                                (x) => x.state === stateSelected
                                              )}].twentyFiveKgPrice`
                                            )}
                                          />
                                          <ErrorMessage
                                            name={`shippingPriceList[${shippingPriceList.findIndex(
                                              (x) => x.state === stateSelected
                                            )}].twentyFiveKgPrice`}
                                            render={(error) => (
                                              <Label
                                                basic
                                                color="red"
                                                content={error}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className={styles.weightInput}>
                                      <div className={styles.weightRange}>
                                        25kg & Above
                                      </div>
                                      <div className={styles.weightTextBox}>
                                        <div>
                                          <InputTemp
                                            inputType="number"
                                            placeholder=""
                                            {...getFieldProps(
                                              `shippingPriceList[${shippingPriceList.findIndex(
                                                (x) => x.state === stateSelected
                                              )}].aboveKgPrice`
                                            )}
                                          />
                                          <ErrorMessage
                                            name={`shippingPriceList[${shippingPriceList.findIndex(
                                              (x) => x.state === stateSelected
                                            )}].aboveKgPrice`}
                                            render={(error) => (
                                              <Label
                                                basic
                                                color="red"
                                                content={error}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                        </div>
                      )}
                    </div>
                  );
                }}
              />

              <div className={styles.footer}>
                <div className={styles.searchAndFilter}>
                  {activeOption === "region" && (
                    <Button
                      positive
                      className={styles.bulkProduct}
                      type="submit"
                      disabled={
                        !isValid ||
                        (values.shippingPriceList.findIndex(
                          (x) => x.region === regionSelected
                        ) !== -1 &&
                          values.shippingPriceList[
                            values.shippingPriceList.findIndex(
                              (x) => x.region === regionSelected
                            )
                          ].status === ShippingPriceStatus.false)
                      }
                    >
                      <div className={styles.positive}>
                        <span>Save</span>
                      </div>
                    </Button>
                  )}
                  {activeOption === "state" && (
                    <Button
                      positive
                      className={styles.bulkProduct}
                      type="submit"
                      disabled={
                        !isValid ||
                        (values.shippingPriceList.findIndex(
                          (x) => x.state === stateSelected
                        ) !== -1 &&
                          values.shippingPriceList[
                            values.shippingPriceList.findIndex(
                              (x) => x.state === stateSelected
                            )
                          ].status === ShippingPriceStatus.false)
                      }
                    >
                      <div className={styles.positive}>
                        <span>Save</span>
                      </div>
                    </Button>
                  )}
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default observer(ShippingLocationIndex);
